import React from 'react';

import { AllResourcesIcon } from '@cloudquery/base-icons';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

import { countFormat } from '../../../../utils/table';

interface AllResourcesItemProps {
  isLoading: boolean;
  isSelected: boolean;
  onClick: () => void;
  totalCount: number;
}

export function AllResourcesItem({
  isLoading,
  isSelected,
  onClick,
  totalCount,
}: AllResourcesItemProps) {
  return (
    <ListItemButton onClick={onClick} selected={isSelected}>
      <ListItemIcon sx={{ mr: 1 }}>
        <AllResourcesIcon />
      </ListItemIcon>
      <ListItemText
        primary={<Typography variant="body2Bold">All resources</Typography>}
        secondary={isLoading ? <Skeleton variant="text" width={30} /> : countFormat(totalCount)}
        sx={{ display: 'inline-flex', gap: 1 }}
      />
    </ListItemButton>
  );
}
